//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/brands/views/main/lan/en';
import editBrand from 'Modules/brands/views/.components/editBrand/lan/en';
import overview from 'Modules/brands/views/overview/lan/en';
import messageTemplatetab from 'Modules/brands/views/.components/messageTemplateTab/lan/en';
import createEditMessageTemplate from 'Modules/brands/views/.components/createEditMessageTemplate/lan/en';
import deleteMessageTemplate from 'Modules/brands/views/.components/deleteMessageTemplate/lan/en';
import deleteBrand from 'Modules/brands/views/.components/deleteBrand/lan/en';


locales = {
    ...locales,
    ...main,
    ...editBrand,
    ...overview,
    ...messageTemplatetab,
    ...createEditMessageTemplate,
    ...deleteMessageTemplate,
    ...deleteBrand,
};


export default locales;